// import { pie as d3_pie } from 'd3-shape'
import { stack as d3_stack } from 'd3-shape'
import { convertRowsToData } from '../utils/dataUtils'
export default function ConnectedDotPlotDataController(rows, config, hiddenItems) {
  let headers = rows[0]
  let propperHeaders
  let dims

  propperHeaders = ['id', ...headers.slice(1)]
  dims = 2
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], dims)

  let keys = data.reduce((res, d) => {
    d.value.forEach(dd => res.push(dd.id))
    return res
  }, [])
  keys = keys.filter((value, index, self) => self.indexOf(value) === index)

  if(hiddenItems) keys = keys.filter((d)=>hiddenItems.indexOf(d)<0)

  let objArray = data.map(layer => {
    let res = { id: layer.id }
    layer.value.forEach(dd => {
      res[dd.id] = {
        value: dd.value,
      }
    })
    return res
  })
  objArray = objArray.map(item => {
    return Object.keys(item)
      .sort((a, b) => item[a].value - item[b].value)
      .reduce((accumulator, key) => {
        accumulator[key] = item[key]
        return accumulator
      }, {})
  })
  let stack = d3_stack().keys(keys)

  let stacked = stack(objArray)
  let result = stacked.map(layer => {
    return {
      id: layer.key,
      index: layer.index,
      value: layer.map((dd, index) => {
        return {
          id: dd.data.id,
          uid: `${layer.key}-${dd.data.id}`,
          value: dd.data[layer.key].value,
          layerIndex: layer.index,
          parentId: layer.key,
        }
      }),
    }
  })
  return result
}

export function getConnectionLines(data) {
  const reducedData = data.reduce((accumulator, current) => {
    current.value.forEach(item => {
      if (!accumulator[item.id]) {
        accumulator[item.id] = {
          id: item.id,
          startConnectionId: item.uid,
          xConnectStart: item.value,
          xConnectEnd: item.value,
        }
      } else {
        if (accumulator[item.id].xConnectStart > item.value) {
          accumulator[item.id].startConnectionId = item.uid,
          accumulator[item.id].xConnectStart = item.value
        }
        if (accumulator[item.id].xConnectEnd < item.value)
          accumulator[item.id].xConnectEnd = item.value
      }
    })
    return accumulator
  }, {})
  return reducedData
}
